import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import _isEmpty from 'lodash/isEmpty';

import FormFields from './FormFields';
import AutoSave from './AutoSave';
import SubmitButton from './SubmitButton';

import {
  Values,
  Fields,
  CustomComponents,
  getDefaultValues,
  getValidationSchema,
} from './utils';

export interface IFormProps {
  fields: Fields;
  values?: Values;
  onSubmit: (values: Values) => void;
  customComponents?: CustomComponents;

  autoSave?: boolean;
  hideSubmit?: boolean;
}

export default function Form({
  fields,
  values,
  onSubmit,
  customComponents,

  autoSave = false,
  hideSubmit = autoSave,
}: IFormProps) {
  const defaultValues = {
    ...getDefaultValues(fields, customComponents),
    ...(values ?? {}),
  };

  const { register, handleSubmit, control, errors } = useForm({
    mode: autoSave ? 'all' : 'onBlur',
    defaultValues,
    resolver: yupResolver(getValidationSchema(fields)),
  });

  const hasErrors = errors
    ? Object.values(errors).reduce((a, c) => !!(a || !_isEmpty(c)), false)
    : false;
  const isSubmitDisabled = hasErrors;

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {autoSave && (
        <AutoSave
          control={control}
          defaultValues={defaultValues}
          errors={errors}
          onSubmit={onSubmit}
        />
      )}

      <FormFields
        fields={fields}
        register={register}
        control={control}
        errors={errors}
        customComponents={customComponents}
      />

      {!hideSubmit && (
        <SubmitButton
          // label={nextButtonLabel}
          disabled={isSubmitDisabled}
        />
      )}
    </form>
  );
}
